import { faPenToSquare } from '@awesome.me/kit-f3dc60f0d0/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from '@lingui/react/macro';
import { Button } from '@repo/videa-components/src/ui/button';

type ConfigurationItemSectionProps = {
  dataCy: string;
  title: string;
  children: React.ReactNode;
  isEditing?: boolean;
  onEdit: () => void;
  onCancel: () => void;
  onSave?: () => void;
  disabled?: boolean;
};

export const ConfigurationItemSection = ({
  dataCy,
  title,
  children,
  isEditing,
  onEdit,
  onCancel,
  onSave,
  disabled = false,
}: ConfigurationItemSectionProps) => {
  return (
    <div className="vai-flex vai-flex-col">
      <div className="vai-flex vai-items-center vai-justify-between vai-bg-gray-100 vai-py-2 vai-px-4 vai-rounded-md">
        <h3 className="vai-font-medium vai-text-gray-900">{title}</h3>
        {isEditing ? (
          <div className="vai-flex vai-gap-2">
            <Button
              data-cy={`cancel-button-${dataCy}`}
              variant="outline"
              size="sm"
              onClick={onCancel}
            >
              <Trans>Cancel</Trans>
            </Button>
            <Button
              data-cy={`save-button-${dataCy}`}
              size="sm"
              disabled={!onSave}
              onClick={onSave}
            >
              <Trans>Save</Trans>
            </Button>
          </div>
        ) : (
          <Button
            data-cy={`edit-button-${dataCy}`}
            variant="ghost"
            size="sm"
            className="vai-text-gray-500 hover:vai-text-gray-700"
            onClick={onEdit}
            disabled={disabled}
          >
            <FontAwesomeIcon icon={faPenToSquare} />
            <Trans>Edit</Trans>
          </Button>
        )}
      </div>
      {children}
    </div>
  );
};
